import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "alert alert-info py-2 px-3 mb-3"
}
const _hoisted_2 = { class: "fw-semibold text-capitalize-first mb-1" }
const _hoisted_3 = { class: "list-unstyled mb-0 small" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.entries.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.helper.trans('labels.payin_balance_available_for_payout')), 1),
        _createElementVNode("ul", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entries, (entry) => {
            return (_openBlock(), _createElementBlock("li", {
              key: entry.currency
            }, [
              _createElementVNode("strong", null, _toDisplayString(entry.currency) + ":", 1),
              _createTextVNode(" " + _toDisplayString(entry.formattedAmount), 1)
            ]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}